import React from 'react';

const RealEstateFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 17V3H16V17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 17V12H12V17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 6.5H12M7.5 9H12" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default RealEstateFilterIcon;
